import { render } from "./AccountDeletion.vue?vue&type=template&id=39bf5dbb&scoped=true&ts=true"
import script from "./AccountDeletion.vue?vue&type=script&lang=ts"
export * from "./AccountDeletion.vue?vue&type=script&lang=ts"

import "./AccountDeletion.vue?vue&type=style&index=0&id=39bf5dbb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39bf5dbb"]])

export default __exports__